import {Component, OnInit, Inject, OnDestroy} from '@angular/core';
import { FormControl } from '@angular/forms';
import {MatDialogRef, MatDialog, MAT_DIALOG_DATA} from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Message } from 'src/app/core/class/message';
import { CommonService } from 'src/app/core/services/common.service';
import { DigitalCertificateService } from 'src/app/core/services/digital-certificate.service';

@Component({
  selector: 'app-save-session-cloud-ca-dialog',
  templateUrl: './save-session-cloud-ca-dialog.component.html',
  styleUrls: ['./save-session-cloud-ca-dialog.component.scss']
})
export class SaveSessionCloudCaDialogComponent implements OnInit {
  duration: number

  constructor(
    public dialogRef: MatDialogRef<SaveSessionCloudCaDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dataDialog: any,
    private dialog: MatDialog,
    private translate: TranslateService,
    private digitalCertificateService: DigitalCertificateService,
    private toastr: ToastrService,
    private commonService: CommonService,
    public message: Message,
  ) {
    this.duration = dataDialog.duration
  }


  ngOnInit() {
    
  }

  getDuration(){
    if(this.duration == -1){
      return ''
    } 
    const hours = Math.floor(this.duration / 60);
    const minutes = this.duration % 60;
    if(minutes != 0 && hours != 0){
      return this.message.getMessage(`digital_certificate_management.duration_session_cloudca`).replace('{0}', `${hours}`).replace('{1}', `${minutes}`)
    } else if(minutes == 0 && hours != 0){
      return this.message.getMessage(`digital_certificate_management.duration_session_cloudca_no_minutes`).replace('{0}', `${hours}`)
    } else if(hours == 0 && minutes != 0 ){
      return this.message.getMessage(`digital_certificate_management.duration_session_cloudca_no_hours`).replace('{0}', `${minutes}`)
    } else {
      return ''
    }
  }

  getContent() {
    return `${this.translate.instant('title.save_sesion_cloud_ca')} ${this.dataDialog.name}`
  }

  onClickBtn() {
    this.dialogRef.close(true);
  }

  closeDialog() {
    this.dialogRef.close(false);
  }

}
